import React, { useEffect, useState } from "react";
import { amountFormat } from "../../utils/WalletUtils";

export const AmountBOA = (props) => {
  const { amount, hideSuffix, className } = props;
  const [left, setLeft] = useState();
  const [right, setRight] = useState();

  useEffect(() => {
    if (amount) {
      const value = amountFormat(amount);
      setLeft(value.substr(0, value.indexOf(".")));
      setRight(value.substring(value.indexOf(".") + 1));
    }
  }, [amount]);

  return (
    <div className={`amountBOA ${className}`}>
      <span>
        {left}
        {"."}
      </span>
      <span>{right}</span>
      {!hideSuffix && <span>{" BOA"}</span>}
    </div>
  );
};
export default React.memo(AmountBOA);
